export default __webpack_public_path__ + "assets/images/select-icon-1ed337cb.svg";